import React from 'react'
import Text from '../text'
import { filterArrayByType } from '../../utility.js'
import * as styles from './index.module.css'

export default ({ body }) => {
  let data = filterArrayByType(body, 'body_text_paragraphs')
  /* console.log('body_text_paragraphs', data) */

  if (data.length === 0) {
    return null
  }

  let blocks = data.pop().items

  return (
    <div className={`${styles.textBlocks} text-blocks`}>
      {blocks[0]?.body_title && (
        <h2 className={styles.bodyTitle}>{blocks[0].body_title.text}</h2>
      )}
      {blocks?.map((d) => {
        if (d.design_style == 'Highlighted') {
          return (
            <div className={`${styles.box} content-box text-block`}>
              <Text>{d.paragraph.richText}</Text>
            </div>
          )
        } else {
          return <Text>{d.paragraph.richText}</Text>
        }
      })}
    </div>
  )
}
